import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 19px;
  font-family: 'Roboto';
  font-weight: 500;
  text-align: center;
  min-height: calc(100vh - 150px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Title = styled.h2`
  color: #1f2431;
  font-size: 19px;
  font-weight: 500;
  line-height: 30px;
  margin-bottom: 10px;
`;
export const Text = styled.p`
  color: #788195;
  margin-bottom: 30px;
  font-size: 14px;
  font-weight: 500;
`;
export const Icon = styled.img`
  width: 250px;
  height: 130px;
  margin-bottom: 20px;
`;
